import { LAYOUTS, } from "@voltmoney/types";
import { SizeTypeTokens, VerificationCardButtonTypeToken, VerificationCardTypeTokens, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION, } from "./types";
import { verifyPledging } from "./actions";
export const template = {
    layout: {
        id: ROUTE.PLEDGE_LOADING,
        type: LAYOUTS.MODAL,
        widgets: [
            { id: "space1", type: WIDGET.SPACE },
            { id: "alert", type: WIDGET.VERIFICATIONCARD },
            //  { id: "stack", type: WIDGET.STACK },
        ],
    },
    datastore: {
        space1: { size: SizeTypeTokens.SM },
        alert: {
            label: 'Rs 30000 unlocked successfully!',
            message: 'You will be redirected to the dashboard few seconds',
            type: VerificationCardTypeTokens.Success,
            buttonType: VerificationCardButtonTypeToken.FULL,
            // buttonText: 'Submit'
            // action: '',
        },
    },
};
export const unlockSuccessMF = {
    onLoad: async () => Promise.resolve(template),
    actions: {
        [ACTION.PLEDGE_VERIFY]: verifyPledging,
    },
};
